exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-59240690] {\n  border-radius: 5px;\n  padding: 16px;\n}\n.item[data-v-59240690] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.name[data-v-59240690] {\n  width: 80px;\n}\n.arrow[data-v-59240690] {\n  width: 40px;\n}\n.and[data-v-59240690] {\n  font-weight: bold;\n}\n.example[data-v-59240690] {\n  margin-top: 16px;\n}\n.explaination[data-v-59240690] {\n  margin-bottom: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59240690","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/organisms/modals/ModalSearchQA.vue
// module id = rGtl
// module chunks = 0